import { render, staticRenderFns } from "./listTab.vue?vue&type=template&id=4865aeb0&scoped=true"
import script from "./listTab.vue?vue&type=script&lang=js"
export * from "./listTab.vue?vue&type=script&lang=js"
import style0 from "./listTab.vue?vue&type=style&index=0&id=4865aeb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4865aeb0",
  null
  
)

export default component.exports